/* A service for making API calls a little easier and less verbose */
import apisauce from 'apisauce';


const api = apisauce.create({
    baseURL: 'https://gamewithvel.es/api/',
    headers: {
        'Content-Type': 'application/json',
    }
});

const velesApi = {
    submitPassword: (password) => {
        return api.post('/authenticate', {password: password});
    },

    requestPassword: (email) => {
        return api.post('/requestPassword', {email: email});
    },

    submitCollectedUserData: (userData) => {
        // return api.post('/proxy', JSON.stringify({test: true}));
        return api.post('/proxy', JSON.stringify(userData));
    }
};

export default velesApi;


// WEBPACK FOOTER //
// ./src/components/App/services/api.js